package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.anjuros.website.templates.template4.components.Template4ProjectCard
import com.anjuros.website.templates.template4.components.Template4SectionTitle
import com.anjuros.website.templates.template4.modules.Template4Project
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.styles.Template4SmallSectionWidthStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEntered
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template4ProjectsSections(selectedGallery:(template4Project:Template4Project)->Unit){
    Box(
        modifier = Modifier
            .id(Template4Section.Project.id)
            .fillMaxSize()
            .padding(bottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        Template4ProjectsContent{
            selectedGallery(it)
        }
    }
}

@Composable
fun Template4ProjectsContent(selectedGallery:(template4Project:Template4Project)->Unit){
    val animatedMargin= remember { mutableStateOf(50.px) }



    Template4ObserverViewportEntered(
        sectionId = Template4Section.Project.id,
        distanceFromTop = 300.0
    ){
        animatedMargin.value=10.px
    }

    Column(
        modifier = Modifier.fillMaxSize()
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template4SectionTitle(
            modifier = Template4SmallSectionWidthStyle.toModifier()
                .margin( bottom = 75.px),
            section = Template4Section.Project,
            alignment = Alignment.CenterHorizontally
        )
    SimpleGrid(numColumns = numColumns( base=1, md=2, lg=3)) {

        Template4Project.entries.forEach { project ->

            Template4ProjectCard(project, animatedMargin.value){
                selectedGallery(it)
            }

        }
    }

    }
}